import { Injectable, inject } from '@angular/core';
import { UserRole } from '@wilson/interfaces';
import { WilsonState } from '@wilson/non-domain-specific/decorators/wilson-state';
import { catchError, Observable, of, tap, throwError } from 'rxjs';
import { RolesService } from './roles.service';

@Injectable({
  providedIn: 'root',
})
export class RolesCacheService {
  private rolesService = inject(RolesService);

  @WilsonState<Record<string, UserRole[]>>({})
  private roles!: Record<string, UserRole[]>;

  private requestsInFlight: Map<string, Observable<UserRole[]>> = new Map();

  getRolesFromCache(userId: string): Observable<UserRole[]> {
    const roles = this.roles[userId];
    if (roles) {
      return of(roles);
    } else {
      const requestInFlight = this.requestsInFlight.get(userId);
      if (requestInFlight) {
        return requestInFlight;
      } else {
        const request = this.rolesService.getUserRoles(userId).pipe(
          tap((roles) => {
            this.roles[userId] = roles;
            this.requestsInFlight.delete(userId);
          }),
          catchError((error) => {
            console.error(`Error fetching roles for user ${userId}:`, error);
            this.requestsInFlight.delete(userId);
            return throwError(() => new Error('Failed to fetch roles'));
          }),
        );

        this.requestsInFlight.set(userId, request);
        return request;
      }
    }
  }

  clearRolesCache(): void {
    this.roles = {};
    this.requestsInFlight.clear();
  }
}
